module.exports = __webpack_public_path__ + "img/effect_mode3.3d1202ad.svg";